export const RECIPES = [
    {
        id: 'whispering_gale',
        name: 'Whispering Gale',
        ingredients: [
            { name: 'Wind Essence', quantity: 1 },
            { name: 'Feather', quantity: 1 },
            { name: 'Cloud Essence', quantity: 1 },
        ],
        tools: ['Bellow', 'Cauldron', 'Mortar', 'Ladle'],
        successRate: 0.65,
        result: 'Whispering Gale',
    },
    {
        id: 'tideheart',
        name: 'Tideheart',
        ingredients: [
            { name: 'Sea Water', quantity: 1 },
            { name: 'Crystal Water', quantity: 1 },
            { name: 'Rainbow Dust', quantity: 1 },
        ],
        tools: ['Bellow', 'Cauldron', 'Mortar', 'Ladle'],
        successRate: 0.8,
        result: 'Tideheart',
    },
    {
        id: 'stoneblood',
        name: 'Stoneblood',
        ingredients: [
            { name: 'Tree Bark', quantity: 1 },
            { name: 'Bone Powder', quantity: 1 },
            { name: 'Volcanic Ash', quantity: 1 },
        ],
        tools: ['Bellow', 'Cauldron', 'Mortar', 'Ladle'],
        successRate: 0.82,
        result: 'Stoneblood',
    },
    {
        id: 'feathered_flame',
        name: 'Feathered Flame',
        ingredients: [
            { name: 'Bottled Sunlight', quantity: 1 },
            { name: 'Feather', quantity: 1 },
            { name: 'Peyote', quantity: 1 },
        ],
        tools: ['Bellow', 'Cauldron', 'Mortar', 'Ladle'],
        successRate: 0.7,
        result: 'Feathered Flame',
    },
    {
        id: 'eternal_silk',
        name: 'Eternal Silk',
        ingredients: [
            { name: 'Holi Powder', quantity: 1 },
            { name: 'Himalayan Snow', quantity: 1 },
            { name: 'Rahu Saliva', quantity: 1 },
        ],
        tools: ['Bellow', 'Cauldron', 'Mortar', 'Ladle'],
        successRate: 0.77,
        result: 'Eternal Silk',
    },
    {
        id: 'coral',
        name: 'Coral',
        ingredients: [
            { name: 'Sea Water', quantity: 1 },
            { name: 'Kangaroo Tail', quantity: 1 },
            { name: 'Araucarian Resine', quantity: 1 },
        ],
        tools: ['Bellow', 'Cauldron', 'Mortar', 'Ladle'],
        successRate: 0.85,
        result: 'Coral',
    },
    {
        id: 'shifting_dunes',
        name: 'Shifting Dunes',
        ingredients: [
            { name: 'Desert Sand', quantity: 1 },
            { name: 'Snake Skin', quantity: 1 },
            { name: 'Mustard Seeds', quantity: 1 },
        ],
        tools: ['Bellow', 'Cauldron', 'Mortar', 'Ladle'],
        successRate: 0.75,
        result: 'Shifting Dunes',
    },
    {
        id: 'forgotten_grove',
        name: 'Forgotten Grove',
        ingredients: [
            { name: 'Garden Flower', quantity: 1 },
            { name: 'Tree Bark', quantity: 1 },
            { name: 'Wolf Fang', quantity: 1 },
        ],
        tools: ['Bellow', 'Cauldron', 'Mortar', 'Ladle'],
        successRate: 0.73,
        result: 'Forgotten Grove',
    },
];

export const rawTools = [
    {
        name: 'Bellow',
        description: 'Used to heat up potions during crafting',
        image: 'bellow-transparent.png',
        key: 'bellow',
    },
    {
        name: 'Cauldron',
        description: 'Essential for mixing ingredients together',
        image: 'cauldron-transparent.png',
        key: 'cauldron',
    },
    { name: 'Ladle', description: 'For transferring potions into flasks', image: 'ladle-transparent.png', key: 'ladle' },
    {
        name: 'Mortar',
        description: 'Grinds ingredients to release their full potential',
        image: 'mortar-transparent.png',
        key: 'mortar',
    },
];

export const rawIngredients = [
    { key: 'aguas_fetidas', image: 'fetidwater.png' },
    'alamorcego',
    'alcoholbeer',
    { key: 'araucarianresine', image: 'araucariar.png' },
    'ash',
    { key: 'bigfootshair', image: 'bigfoothr.png' },
    'blood',
    'bonepowder',
    'cloud',
    'corteza',
    { key: 'diamantebruto', image: 'diamond.png' },
    'feather',
    'flor_de_algodon',
    { key: 'gardenflower', image: 'gardeflow.png' },
    'gardensoil',
    { key: 'herbadeetiopia', image: 'poisonherb.png' },
    { key: 'holi', image: 'holiwater.png' },
    'horndust',
    { key: 'hymalayansnow', image: 'himalayasn.png' },
    { key: 'kangarootail', image: 'kangaroohr.png' },
    'lava',
    { key: 'lightninggg', image: 'lightning.png' },
    { key: 'mustardseeds', image: 'mustardsd.png' },
    'peyote',
    { key: 'pluma', image: 'feather.png' },
    'poisonherb',
    { key: 'rainboudust', image: 'rainbowshd.png' },
    { key: 'rahusaliva', image: 'rahussaliv.png' },
    { key: 'sand', image: 'desentsand.png' },
    'skin',
    'sunlight',
    { key: 'vampirefang', image: 'vampirefng.png' },
    { key: 'watercristaline', image: 'crystwater.png' },
    { key: 'water_sea', image: 'seawater.png' },
    'wind',
    { key: 'wolfsfang', image: 'wolffang.png' },
];

// Mapping of image file names to proper names (matching Inventory and Market)
export const ingredientNameMap = {
    aguas_fetidas: 'Fetid Waters',
    alamorcego: 'Bat Wing',
    alcoholbeer: 'Alcohol Beer',
    araucarianresine: 'Araucarian Resine',
    ash: 'Volcanic Ash',
    bigfootshair: 'Bigfoot Hair',
    blood: 'Blood',
    bonepowder: 'Bone Powder',
    cloud: 'Cloud Essence',
    corteza: 'Tree Bark',
    diamantebruto: 'Raw Diamond',
    feather: 'Feather',
    flor_de_algodon: 'Cotton Flower',
    gardenflower: 'Garden Flower',
    gardensoil: 'Garden Soil',
    herbadeetiopia: 'Ethiopian Herb',
    holi: 'Holi Powder',
    horndust: 'Horn Dust',
    hymalayansnow: 'Himalayan Snow',
    kangarootail: 'Kangaroo Tail',
    lava: 'Volcano Lava',
    lightninggg: 'Lightning Essence',
    mustardseeds: 'Mustard Seeds',
    peyote: 'Peyote',
    pluma: 'Feather',
    poisonherb: 'Poison Herb',
    rainboudust: 'Rainbow Dust',
    rahusaliva: 'Rahu Saliva',
    sand: 'Desert Sand',
    skin: 'Snake Skin',
    sunlight: 'Bottled Sunlight',
    vampirefang: 'Vampire Blood',
    watercristaline: 'Crystal Water',
    water_sea: 'Sea Water',
    wind: 'Wind Essence',
    wolfsfang: 'Wolf Fang',
};

export const realAssetIds = {
    // Ingredients
    aguas_fetidas: '7464041035414516620',
    alcoholbeer: '2795734210888256790',
    blood: '16326649816730553703',
    watercristaline: '13321324699537252353',
    water_sea: '16876168465973703622',
    cloud: '15521713672709080827',
    lightninggg: '9289482442465517140',
    wind: '65767141008711421',
    sunlight: '8717959006135737805',
    lava: '955451625820789680',
    flor_de_algodon: '6086151229884242778',
    gardenflower: '7879802689430656608',
    corteza: '1941380340903453000',
    herbadeetiopia: '5528548442683058721',
    poisonherb: '15080124236445648438',
    mustardseeds: '2820535047226119418',
    peyote: '12313032092046113556',
    alamorcego: '8825927167203958938',
    bigfootshair: '2380273644117095987',
    feather: '11386383170019744285',
    kangarootail: '1748542894784204097',
    vampirefang: '14451010716011965584',
    wolfsfang: '7563318252261495089',
    araucarianresine: '7081966488954575750',
    ash: '12210617625866540653',
    bonepowder: '10290172289119183466',
    diamantebruto: '7384993574556043649',
    gardensoil: '9422436625653721006',
    horndust: '9093191442487829960',
    hymalayansnow: '9859593227468066316',
    pluma: '15230533556325993984',
    skin: '9627155908350599600',
    sand: '3042874600616626102',
    rahusaliva: '17969181894960429964',
    rainboudust: '18140737140039335538',
    holi: '12308228721908498397',
    // Tools
    bellow: '134965209883026568',
    cauldron: '16510405738781556809',
    ladle: '16675035144675396134',
    mortar: '891244524698574104',
    // Flasks
    conical_flask: '15449537292115398209',
    pear_flask: '7733730178178340688',
    kjeldahl_flask: '10988806909985982048',
    florence_flask: '8654762646210741353',
    round_flask: '18264820454208225977',
    // Potions (Creations)
    whispering_gale: '6485210212239811',
    tideheart: '7582224115266007515',
    stoneblood: '10474636406729395731',
    eternal_silk: '5089659721388119266',
    coral_spirits: '8693351662911145147',
    feathered_flame: '11206437400477435454',
    shifting_dunes: '12861522637067934750',
    forgotten_grove: '3858707486313568681',
};

export const rawFlasks = [
    {
        name: 'Conical Flask',
        description: 'Specialized conical laboratory flask',
        image: 'conicalfl-transparent.png',
        key: 'conical_flask',
    },
    {
        name: 'Pear-Shaped Flask',
        description: 'Unique pear-shaped distillation flask',
        image: 'pearshapfl-transparent.png',
        key: 'pear_flask',
    },
    {
        name: 'Kjeldahl Flask',
        description: 'Professional analytical flask',
        image: 'kjeldahlf-transparent.png',
        key: 'kjeldahl_flask',
    },
    {
        name: 'Florence Flask',
        description: 'Classic round-bottom florence flask',
        image: 'florencef-transparent.png',
        key: 'florence_flask',
    },
    {
        name: 'Round-Bottom Flask',
        description: 'Standard round-bottom flask',
        image: 'roundbtmf-transparent.png',
        key: 'round_flask',
    },
];

export const rawPotions = [
    {
        name: 'Whispering Gale Potion',
        description: 'Harnesses the power of wind and storms',
        image: 'PotionWhisperingGale.png',
        key: 'whispering_gale',
    },
    {
        name: 'Tideheart Potion',
        description: 'Contains the essence of ocean tides',
        image: 'PotionTideheart.png',
        key: 'tideheart',
    },
    {
        name: 'Stoneblood Potion',
        description: 'Infused with the strength of mountains',
        image: 'PotionStoneblood .png',
        key: 'stoneblood',
    },
    {
        name: 'Eternal Silk Potion',
        description: 'Woven with ancient Asian wisdom',
        image: 'PotionofheEternalSilk.png',
        key: 'eternal_silk',
    },
    {
        name: 'Coral Spirits Potion',
        description: 'Blessed by oceanic guardians',
        image: 'PotionCoral.png',
        key: 'coral_spirits',
    },
    {
        name: 'Feathered Flame Potion',
        description: 'Burns with the spirit of the Americas',
        image: 'PotionoftheFeatheredFlame.png',
        key: 'feathered_flame',
    },
    {
        name: 'Shifting Dunes Potion',
        description: 'Distilled from desert mirage and mineral heat',
        image: 'Potion of the Shifting Dunes.png',
        key: 'shifting_dunes',
    },
    {
        name: 'Forgotten Grove Potion',
        description: 'Carries the memory of old roots and living bark',
        image: 'PotionoftheForgottenGrove.png',
        key: 'forgotten_grove',
    },
];

export const DURATION_OPTIONS = [
    { blocks: 1440, days: 1 },
    { blocks: 2880, days: 2 },
    { blocks: 4320, days: 3 },
    { blocks: 5760, days: 4 },
    { blocks: 7200, days: 5 },
    { blocks: 14400, days: 10 },
    { blocks: 21600, days: 15 },
    { blocks: 28800, days: 20 },
    { blocks: 43200, days: 30 },
];
